import React, { FC } from 'react';
import { Weld, CommodityMilestone, ProjectMilestoneType } from '@bechtel/types';
import {
  ButtonSize,
  SideSheet,
  SideSheetSize,
  SideSheetHeader,
  SideSheetClose,
  SideSheetSubHeader,
} from '@bechtel/gds';
import { t } from '@lingui/macro';
import { WeldSubHeader } from '~/components/molecules';
import { WeldSendBack } from '../weld-send-back/internals';
interface WeldSendBackSideSheetProps {
  weld: Weld;
  currentMilestone: CommodityMilestone;
  fitUpMilestone: CommodityMilestone;
  fitupProjectMilestoneDetails: ProjectMilestoneType;
  isSendBackToForeman?: boolean;
  close: () => void;
  refetchQueries?: string[];
}

export const WeldSendBackSideSheet: FC<WeldSendBackSideSheetProps> = ({
  close,
  weld,
  fitupProjectMilestoneDetails,
  currentMilestone,
  fitUpMilestone,
  isSendBackToForeman = false,
  refetchQueries,
}) => {
  return (
    <SideSheet
      data-testid="side-sheet-container"
      size={SideSheetSize.DEFAULT}
      visible
      style={{
        boxShadow: `0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14)`,
      }}
    >
      <SideSheetHeader
        data-testid="side-sheet-header"
        title={`${t`Send Back to`} ${!isSendBackToForeman ? t`Piping` : t`Foreman`}`}
      >
        <SideSheetClose onClick={close} size={ButtonSize.SMALL}></SideSheetClose>
      </SideSheetHeader>
      <SideSheetSubHeader>
        <WeldSubHeader
          tag={weld?.tag}
          pipeMaterial={weld?.pipeMaterial ? weld?.pipeMaterial : ''}
          pipeDiameter={weld?.pipeDiameter ? weld?.pipeDiameter : 0}
        />
      </SideSheetSubHeader>
      <WeldSendBack
        currentMilestone={currentMilestone}
        fitUpMilestone={fitUpMilestone}
        commodityStatus={weld.status?.status}
        fitupProjectMilestoneDetails={fitupProjectMilestoneDetails}
        isSendBackToForeman={isSendBackToForeman}
        onClose={close}
        refetchQueries={refetchQueries}
      />
    </SideSheet>
  );
};
